import {Writable} from 'utility-types';

export type ReadonlyOrWritable<T> = Readonly<T> | Writable<T>;
